import { baseSplitApi } from '../baseApi';
import { GET_ALL_RFP_TAG } from './rfq.service';

const cipClientPath = "/cip_client";
const generateProposalTempURLPath = "generate_link_for_proposal_template"
const GET_ALL_CLIENTS_TAG = 'GET_ALL_CLIENTS'
const generateSessionForCIPPath = "generate_token_for_cip"

export const cipClientApi = baseSplitApi.injectEndpoints({
  endpoints: (build) => ({
    getAllClients: build.query({
      query: () => {
        return {
          url: `${cipClientPath}`,
          method: 'GET',
        }
      },
      providesTags: [GET_ALL_CLIENTS_TAG]
    }),
    addCipClient: build.mutation({
      query: (clientPayload) => {
        return {
          url: `${cipClientPath}`,
          method: "POST",
          body: clientPayload
        }
      },
      invalidatesTags: [GET_ALL_CLIENTS_TAG]
    }),
    addCipClientsByExcel: build.mutation({
      query: (clientPayload) => {
        return {
          url: `${cipClientPath}/add_clients_by_excel`,
          method: "POST",
          body: clientPayload
        }
      },
      invalidatesTags: [GET_ALL_CLIENTS_TAG]
    }),
    onboardClientsByExcel: build.mutation({
      query: (clientPayload) => {
        return {
          url: `${cipClientPath}/onboard_clients_by_excel`,
          method: "POST",
          body: clientPayload
        }
      },
      invalidatesTags: [GET_ALL_CLIENTS_TAG]
    }),
    getClientTypesAndIndustry: build.query({
      query: () => {
        return {
          url: `${cipClientPath}/types`,
          method: "GET"
        }
      }
    }),

    getAClient: build.mutation({
      query: (id) => {
        return {
          url: `${cipClientPath}/${id}`,
          method: "GET"
        }
      }
    }),

    updateAClient: build.mutation({
      query: ({ id, payload }) => {
        return {
          url: `${cipClientPath}/${id}`,
          method: "PUT",
          body: payload
        }
      },
      invalidatesTags: [GET_ALL_CLIENTS_TAG]
    }),
    generateSessionForCIP: build.query({
      query: () => {
        return {
          url: `${cipClientPath}/${generateSessionForCIPPath}`
        }
      }
    }),
    toggleIsActiveClient: build.mutation({
      query: (id) => {
        return {
          url: `${cipClientPath}/toggleIsActive/${id}`,
          method: "PUT"
        }
      },
      invalidatesTags: [GET_ALL_CLIENTS_TAG]
    }),
    generatePreviewURLForProposalTemplate: build.mutation({
      query: ({ id, proposalTemplateType }) => {
        return {
          url: `${cipClientPath}/${generateProposalTempURLPath}/${id}?isPreview=true&proposalTemplateType=${proposalTemplateType}`,
          method: 'POST'
        }
      }
    }),
    generatePreviewURLForClientProposal: build.mutation({
      query: id => {
        return {
          url: `${cipClientPath}/${generateProposalTempURLPath}/${id}?isPreview=false`,
          method: 'POST'
        }
      },
      invalidatesTags: [GET_ALL_RFP_TAG]
    }),
    generateReadOnlyPreviewForClient: build.mutation({
      query: id => {
        return {
          url: `${cipClientPath}/generate_read_only_link_for_proposal_template/${id}`,
          method: "POST"
        }
      }
    }),

    generateKmtRfq: build.mutation({
      query: body => {
        return {
          url: `/rfq/kmt_rfq`,
          body: body,
          method: "POST"
        }
      },
      invalidatesTags: [GET_ALL_RFP_TAG],
      transformResponse: (data) => data.data[0]
    })
  }),

  overrideExisting: false,
})

// These hooks gets auto generated based on endpoints
export const { useGetAllClientsQuery, useGenerateKmtRfqMutation, useGeneratePreviewURLForProposalTemplateMutation, useGenerateReadOnlyPreviewForClientMutation, useGeneratePreviewURLForClientProposalMutation, useGenerateSessionForCIPQuery, useAddCipClientMutation, useAddCipClientsByExcelMutation, useOnboardClientsByExcelMutation, useGetClientTypesAndIndustryQuery, useGetAClientMutation, useUpdateAClientMutation, useToggleIsActiveClientMutation } = cipClientApi;